import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { bemCssModules } from '@src/utils';

import Button from '@components/Button';

import Cookie from './Cookie';
import CrossIcon from './cross.svg';
import { useCookieContext } from '../context';
import { cookieOptions } from '../helpers';

import style from './CookieManager.scss';

const cn = bemCssModules(style, 'CookieManager');

type CookieManagerType = {
  handleClose(): void;
};

const CookieManager: CustomFC<CookieManagerType> = ({ className, handleClose }) => {
  const { t } = useTranslation();
  const { acceptAllCookies, acceptSelectedCookies } = useCookieContext();

  return (
    <div className={cn(null, [className])}>
      <div className={cn('header')}>
        <button onClick={handleClose} className={cn('cross')}>
          <CrossIcon />
        </button>
        <div className={cn('title')}>{t('cookies.settings.header')}</div>
      </div>
      <div className={cn('description')}>{t('cookies.settings.description')}</div>
      <div className={cn('description')}>
        <Trans i18nKey="cookies.settings.description2">
          <a className={cn('link', ['link'])} href="https://mercuryo.io/legal/cookies">
            Cookie Policy
          </a>
        </Trans>
      </div>
      <div className={cn('cookies')}>
        {cookieOptions.map(cookie => {
          return <Cookie key={cookie.id} cookie={cookie} />;
        })}
      </div>
      <div className={cn('buttons')}>
        <Button className={cn('button')} onClick={acceptSelectedCookies}>
          {t('cookies.settings.save')}
        </Button>
        <Button className={cn('button')} outline onClick={acceptAllCookies}>
          {t('cookies.settings.save_all')}
        </Button>
      </div>
    </div>
  );
};

export default CookieManager;
